<template>
    <div id="show">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-pencil"></i> Sentences</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <div class="field">
                  <label class="label">Id:</label>
                  <div class="control">
                    <span>{{item.id}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                  <label class="label">Text:</label>
                  <div class="control">
                    <span>{{item.text}}</span>
                  </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Categories:</label>
                    <div class="control" v-for="cat in item.premadeCategories">
                        <p>{{cat.name}}</p>
                    </div>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <label class="label">Schools:</label>
                    <div class="control" v-if="!item.schools">All schools</div>
                    <div v-else class="control" v-for="school in item.schools">
                        <p>{{school.name}}</p>
                    </div>
                </div>
            </div>

            <div class="column is-2 is-pulled-right"> 
                <a href="javascript:history.go(-1)" class="button is-block">
                    Back
                </a>                
            </div>                        
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'premade-sentences-show',
  components: {},
  data() {
        return {
            item: {},
        }
  },
  created(){  
    this.getPremadeSentence(this.$route.params.id);
  },
  methods: {
      getPremadeSentence(id){
        this.premadeSentenceRepo.get(id).then(response => {
            this.item = response.data.data;
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-sentences/Show.vue